import type { TFaqItem } from './types';

export const getFilteredItems = (
  items: Array<TFaqItem>,
  searchValue: string,
  selectedTag: string
) => {
  if (selectedTag) {
    const itemsList = items.filter((item) => {
      if (!item.topics) return false;
      const _topics = item?.topics.join('/').toLocaleLowerCase().replace(' ', '_').split('/');
      return _topics.includes(selectedTag);
    });
    return itemsList;
  }

  if (searchValue) {
    const itemsList = items.filter((faqItem) => {
      if (!searchValue && !selectedTag) return false;

      const question = faqItem.question.toLowerCase();
      const answer = faqItem.answer;

      const contentArray = answer?.content.map((currentValue) => {
        const contentText = currentValue?.content.map((contentItem) =>
          contentItem?.text ? contentItem?.text.toLocaleLowerCase() : ''
        );
        return contentText;
      });

      const contentString = contentArray.join(' ');

      if (
        question.includes(searchValue.toLocaleLowerCase()) ||
        contentString.includes(searchValue.toLocaleLowerCase())
      ) {
        return true;
      }
    });
    return itemsList;
  }

  return [];
};
